import toast from 'react-hot-toast'
import api from 'services/api'
import errorHandler from 'utils/errorHandler'

const formatAndDownloadFile = (response, docId, filename) => {
    const url = window.URL.createObjectURL(response.data)
    const a = document.createElement('a')
    a.href = url
    a.download = `${filename}_${docId}.pdf`
    a.click()
    a.remove()
    setTimeout(() => window.URL.revokeObjectURL(url), 100)
}

const downloadPayslipObject = (contractId, referencePeriod, fields) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando holerite do(a) estágiario(a)... `);
    api
      .post(
        `report`,
        {
          reportName: `payslip`,
          params: { id: contractId, period: referencePeriod, fields: fields },
        },
        { responseType: `blob` }
      )
      // api.post(`report`, { reportName: `rpt_contrato_estagio`, params: { id: contractId } }, { responseType: `blob` })
      .then((response) => {
        formatAndDownloadFile(response, contractId, `holerite`);
        dispatch({ type: "CONTRACT_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};
const downloadContractObject = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando contrato de estágio... `);
    api
      .post(
        `report`,
        { reportName: `contract`, params: { id: contractId } },
        { responseType: `blob` }
      )
      // api.post(`report`, { reportName: `rpt_contrato_estagio`, params: { id: contractId } }, { responseType: `blob` })
      .then((response) => {
        formatAndDownloadFile(response, contractId, `contrato`);
        dispatch({ type: "CONTRACT_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadContractTerminationCalc = (contractId, fields) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando calculo de rescisão... `);
    api
      .post(
        `report`,
        {
          reportName: `termination_calc`,
          params: { id: contractId, fields: fields },
        },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `calc-rescisao`);
        dispatch({ type: "TERMINATION_CALC_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadContractTerminationTerm = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando termo de rescisão... `);
    api
      .post(
        `report`,
        { reportName: `termination_term`, params: { id: contractId } },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `termo-rescisao`);
        dispatch({ type: "TERMINATION_TERM_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadContractDismissalLetter = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando carta de dispensa... `);
    api
      .post(
        `report`,
        { reportName: `contract_dismissal`, params: { id: contractId } },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `carta-dispensa`);
        dispatch({ type: "DISMISSAL_LETTER_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadContractAgreeTerm = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando termo de concordância... `);
    api
      .post(
        `report`,
        { reportName: `agree_term`, params: { id: contractId } },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `termo-concordancia`);
        dispatch({ type: "AGREE_TERM_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadContractExtensionTerm = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(
      `Baixando termo de prorrogação de contrato... `
    );
    api
      .post(
        `report`,
        { reportName: `contract_extension`, params: { id: contractId } },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `termo-prorrogacao`);
        dispatch({ type: "CONTRACT_EXTENSION_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadActivityPlanForm = (contractId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando plano de atividade... `);
    api
      .post(
        `report`,
        { reportName: `activity_plan`, params: { id: contractId } },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `plano-atividades`);
        dispatch({ type: "ACTIVITY_PLAN_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadCustomerEvaluationForm = (contractId, referencePeriod) => {
  return (dispatch) => {
    let toastId = toast.loading(
      `Baixando ficha de avaliação de desempenho... `
    );
    api
      .post(
        `report`,
        {
          reportName: `performance_eval`,
          params: { id: contractId, period: referencePeriod },
        },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, contractId, `avaliacao-desempenho`);
        dispatch({ type: "EVALUATION_FORM_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

const downloadCustomerRelations = (companyId) => {
  return (dispatch) => {
    let toastId = toast.loading(`Baixando lista de estagiários da empresa... `);
    api
      .post(
        `report`,
        {
          reportName: `list_trainees_by_company`,
          params: { companyId: companyId },
        },
        { responseType: `blob` }
      )
      .then((response) => {
        formatAndDownloadFile(response, companyId, `relacao-estagiarios`);
        dispatch({ type: "EVALUATION_FORM_DOWNLOAD" });
        toast.success(`Arquivo baixado com sucesso. `);
      })
      .catch((err) => toast.error(`Erro ao baixar: ${errorHandler(err)}`))
      .finally(() => toast.dismiss(toastId));
  };
};

export {
  downloadContractObject,
  downloadContractTerminationCalc,
  downloadContractTerminationTerm,
  downloadContractDismissalLetter,
  downloadCustomerEvaluationForm,
  downloadContractExtensionTerm,
  downloadContractAgreeTerm,
  downloadActivityPlanForm,
  downloadCustomerRelations,
  downloadPayslipObject,
};
